<div mat-dialog-title><mat-icon class="title align-middle">person</mat-icon>{{ dialogTitle | translate:locale.language }}</div>
<div mat-dialog-content>
  <ng-container *ngIf="contact; else loading">
    <div id="contact-name" class="row-item">
      <span class="summary-label"><mat-icon>person</mat-icon>{{ 'Name' | translate:locale.language}}:</span>
      <div>{{ contact.firstName }} {{ contact.lastName }}</div>
    </div>
    <div id="contact-type" class="row-item" *ngIf="contact.type">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ 'Type' | translate:locale.language}}:</span>
      <div>{{ contact.type }}</div>
    </div>
    <div id="contact-title" class="row-item" *ngIf="contact.title">
      <span class="summary-label"><mat-icon>business_center</mat-icon>{{ 'Title' | translate:locale.language}}:</span>
      <div>{{ contact.title }}</div>
    </div>
    <div id="contact-asset" class="row-item" *ngIf="contact.asset">
      <span class="summary-label"><mat-icon>business</mat-icon>{{ 'Facility' | translate:locale.language}}:</span>
      <div>
        <a class="popup" href="javascript:;" (click)="loadAsset()" rel="noopener">{{ contact.asset?.name }}<mat-icon>open_in_new</mat-icon></a>
      </div>
    </div>
    <div id="contact-email" class="row-item" *ngIf="contact.emails?.length">
      <span class="summary-label"><mat-icon>email</mat-icon>{{ 'Email' | translate:locale.language}}:</span>
      <div>
        <span *ngFor="let email of contact.emails">
          <a href="{{ 'mailto:' + email.address }}" target="_blank" rel="noopener"> {{ email.address }}
            <span class="popup"><mat-icon>open_in_new</mat-icon></span>
          </a><br>
        </span>
      </div>
    </div>
    <div id="contact-phone" class="row-item" *ngIf="contact.phones?.length">
      <span class="summary-label"><mat-icon>local_phone</mat-icon>{{ 'Phone' | translate:locale.language}}:</span>
      <div>
        <span *ngFor="let phone of contact.phones">
          {{ phone.phoneType }}: <a href="{{ 'tel:' + phone.number | phone }}" target="_blank" rel="noopener"> {{ phone.number | phone }}
            <span class="popup"><mat-icon>open_in_new</mat-icon></span>
          </a><br>
        </span>
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="row">
      <app-loading [hasFailed]="!!loadError" [failTitle]="loadError" [hideRetry]="hideRetry" (retryClicked)="loadContact()"></app-loading>
    </div>
  </ng-template>
</div>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" id="closeContact" (click)="closeDialogs()">{{ 'Close' | translate:locale.language }}</button>
</div>